// extracted by mini-css-extract-plugin
export default {"body":"PaymentModal_body__0H+-c","background":"PaymentModal_background__GUa1z"};